import { useEffect, useState } from 'react'
import Loader from '../../../components/ui/Loader/Loader';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import TapIcon from '../../../services/TapIcon';
import HttpAPICall from '../../../services/HttpAPICall';
import { BACKOFFICE_BASE_URL } from '../../../services/TapApiUrls';
import { useSelector } from 'react-redux';
import AssetMatrixSCSListing from './AssetMatrixSCSListing';

export default function AssetMatrixDetail({assetMatrixId}) {

    const assetMatrixUrl        =   BACKOFFICE_BASE_URL + '/asset_matrix';
    const access_token          =   useSelector(state => state.auth.access_token);
    const permissionsFromStore  =   useSelector(state => state.app.acl_info?.permissions || []);

    const [detailLoading, setDetailLoading] =   useState(false);
    const [detailData, setDetailData]       =   useState({});
    const [showTab, setShowTab]             =   useState('detail');

    useEffect(() => {
        getDetail();
    }, [assetMatrixId]);

    const getDetail =   ()  => {
        setDetailLoading(true);
        HttpAPICall.withAthorization('GET', assetMatrixUrl + '/detail/' + assetMatrixId, access_token, {}, {}, (resp) => {
            const respData = resp.data;
            setDetailData(respData);
        }).then(() => setDetailLoading(false));
    }

    const assetMatrixDetailJsx = () => {
        return (
            <div className='col-12'>
                <div className='h-100'>
                    <div className='row mt-1 pe-1'>
                        <div className='col-9'>
                            <div className='row ml1'>
                                <div className='col-12 pl0 bg-white'>
                                    <section className="item_view_container bg-white">
                                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link active" id="details-tab" data-bs-toggle="tab" data-bs-target="#details"
                                                    type="button" role="tab" aria-controls="details" aria-selected="true" onClick={() => setShowTab('detail')}>Details
                                                </button>
                                            </li>
                                            {/* <li className="nav-item" role="presentation">
                                                <button className="nav-link" id="Document-tab" data-bs-toggle="tab" data-bs-target="#Document"
                                                    type="button" role="tab" aria-controls="Document" aria-selected="true" disabled={detailLoading} onClick={() => setShowTab('doc')}>Document
                                                </button>
                                            </li> */}
                                            <li className="nav-item" role="presentation">
                                                <button className="nav-link" id="checksheet-tab" data-bs-toggle="tab" data-bs-target="#checksheet"
                                                    type="button" role="tab" aria-controls="checksheet" aria-selected="true" disabled={detailLoading} onClick={() => setShowTab('linkSCS')}>Linked CheckSheet
                                                </button>
                                            </li>
                                        </ul>
                                        <div className="tab-content" id="myTabContent">
                                            <div className="tab-pane  show active" id="details" role="tabpanel" aria-labelledby="details-tab">
                                                {
                                                    showTab === 'detail' &&
                                                    detailLoading ? <Loader />
                                                    : <>
                                                        <div className="tab_content_header">
                                                            <div className="tab_content_wrapper"> <span className="content_heading"> Detail</span></div>
                                                            <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                                                                <tbody className='resource_table'>
                                                                    <tr>
                                                                        <td style={{ width: "25%" }}>Asset Matrix ID</td>
                                                                        <th>{detailData.asset_matrix_unique_id}</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ width: "25%" }}>Asset Type</td>
                                                                        <th>{detailData.asset_type ? detailData.asset_type.asset_type_name : ''}</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ width: "25%" }}>Manufacturer</td>
                                                                        <th>{detailData.manufacturer ? detailData.manufacturer.manufacturer : ''}</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ width: "25%" }}>Model</td>
                                                                        <th>{detailData.model ? detailData.model.model : ''}</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ width: "25%" }}>Variant</td>
                                                                        <th>{detailData.variant}</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ width: "25%" }}>Asset Capacity</td>
                                                                        <th>{detailData.capacity}</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ width: "25%" }}>Fuel Type</td>
                                                                        <th>{detailData.fuel_type ? detailData.fuel_type.fuel_type : ''}</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ width: "25%" }}>Fuel Tank Capacity</td>
                                                                        <th>{detailData.fuel_tank_capacity}</th>
                                                                    </tr>
                                                                    <tr>
                                                                        <td style={{ width: "25%" }}>Electrical System Specification</td>
                                                                        <th>{detailData.electrical_system}</th>
                                                                    </tr>
                                                                    {/* <tr>
                                                                        <td style={{ width: "25%" }}>Asset Matrix Photograph</td>
                                                                        <th>{detailData}</th>
                                                                    </tr> */}
                                                                </tbody>
                                                            </table>
                                                            {availableMetersJsx()}
                                                        </div>
                                                    </>
                                                }
                                            </div>
                                            <div className="tab-pane" id="Document" role="tabpanel" aria-labelledby="Document-tab">
                                                <div className="tab_content_header">
                                                    <div className="tab_content_wrapper"> <span className="content_heading"> Document</span>
                                                    </div>
                                                    <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                                                        <thead className="table-secondary">
                                                            <tr className='text-center'>
                                                                <th style={{ width: "10%" }}>S.No</th>
                                                                <th style={{ width: "15%" }}>Document Name</th>
                                                                <th style={{ width: "15%" }}>Document Number</th>
                                                                <th style={{ width: "15%" }}>Document File</th>
                                                                <th style={{ width: "15%" }}>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {/* {detail_loading ? <tr className='text-center'>
                                                                <td colSpan={5}><Loader /></td>
                                                            </tr> :  */}
                                                            {/* document_listing && document_listing.length > 0
                                                                ? document_listing.map((ts, key) => {
                                                                    return ( */}
                                                            <tr >
                                                                <td className='text-center'>1
                                                                    {/* {documentlistingMeta ? documentlistingMeta.from + key : key} */}
                                                                </td>
                                                                <td>{detailData?.name}</td>
                                                                <td className='text-center'>{detailData?.status}</td>
                                                                <td className='text-center'>j</td>
                                                                <td className='text-center link-primary cursor_pointer' >
                                                                    View Document
                                                                </td>
                                                            </tr>
                                                            {/* )
                                                                }) */}
                                                            {/* : <tr className='text-center'>
                                                                    <td colSpan={5}>No Record</td>
                                                                </tr>} */}

                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div className="tab-pane" id="checksheet" role="tabpanel" aria-labelledby="checksheet-tab">
                                                {
                                                    showTab === 'linkSCS' && 
                                                        <AssetMatrixSCSListing detailData={detailData}/>
                                                }
                                            </div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                        {
                            assetMatrixCard()
                        }
                    </div>
                </div>
            </div>);
    }

    const assetMatrixCard = () => {
        return (
        <>
        <div className='col-3  page_containt  pl4 pr4' style={{ top: "0px", height: "81vh" }}>
            <div className='pageTbl  bg-white' style={{ overflowY: "auto" }}>
                <table className="table table-hover  bg-white p-0">
                    <tbody>
                        <tr>
                            <img className='w-100 h-100' src={`${detailData.asset_matrix_image}`} alt="asset matrix pic"/>
                        </tr>
                        <tr>
                            <td>Asset Matrix ID : <br />
                                <span className="pt-2"> <b> {detailData.asset_matrix_unique_id}</b></span>
                            </td>
                        </tr>
                        <tr>
                            <td>Asset Type  :
                                <span className="pt-2"> <b>  {detailData.asset_type ? detailData.asset_type.asset_type_name : "-"}</b></span>
                            </td>
                        </tr>
                        <tr>
                            <td>Manufacturer  :
                                <span className="pt-2"> <b>  {detailData.manufacturer ? detailData.manufacturer.manufacturer : "-"}</b></span>
                            </td>
                        </tr>
                        <tr>
                            <td>Model  :
                                <span className="pt-2"> <b>  {detailData.model ? detailData.model.model : "-"}</b></span>
                            </td>
                        </tr>

                        <tr>
                            <td className="fs14 fw-normal" >Varaint : <span className="pt-2"><b>{detailData.variant}</b></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        </>
        )
    }

    const availableMetersJsx   =   ()  => {
        return (
            <>
                <div className="tab_content_wrapper"> <span className="content_heading">Available Meters</span></div>
                <table className="table table-hover table-bordered  table-responsive bg-white my-2 ">
                    <thead className="table-secondary">
                        <tr className='text-center'>
                            <th>Label</th>
                            <th>Original Name</th>
                            <th>Limit</th>
                            <th>Unit</th>
                            <th>Available</th>
                        </tr>
                    </thead>
                    <tbody className='resource_table'>
                        {
                            detailData?.meter_data?.length > 0 
                            ? 
                            detailData?.meter_data.map(md => (
                            <tr key={md.key}>
                                <td>{md.label || '-'}</td>
                                <td>{md.name}</td>
                                <td>{md.limit}</td>
                                <td>{md.unit}</td>
                                <td>{md.available}</td>
                            </tr>
                            ))
                            :
                            <tr className='text-center'><td colSpan={5}>No Available Meters</td></tr>
                        }
                    </tbody>
                </table>
            </>
        )
    }


  return (
    <>
        {assetMatrixDetailJsx()}
    </>
  )
}
